import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
} from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import LogoImageVNL from '../../assets/images/VNL_logo.svg';
import { ROUTE_NEWSLETTER_SETTINGS } from '../../config/routes';

import SpotlerSubscriptionForm from '../../components/Form/SpotlerSubscriptionForm';

import { DEFAULT_LANGUAGE, GTM_SOURCE_BANNER, GTM_SOURCE_NEWSLETTER_PAGE } from '../../config/constants';

const SpotlerSubscription = () => {
  const PAGE_TITLE = 'Nieuwsbrief | VeiligheidNL';
  const history = useHistory();
  const loggedIn = useSelector((state) => state.getIn(['login', 'loggedIn'], null));
  const { t } = useTranslation();
  const [formSuccess, setFormSuccess] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  const email = queryParams.get('email');

  useEffect(() => {
    if (loggedIn) {
      history.push(ROUTE_NEWSLETTER_SETTINGS);
    }
  }, [loggedIn]);

  return (
    <div>
      <Helmet
        htmlAttributes={{
          lang: DEFAULT_LANGUAGE,
        }}
      >
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <Container small>
        <div className="FormPage PageSubscribeNewsletter PageMinimal" id="main">
          <div className="PageMinimal__top">
            <CoreLink className="Logo" href="/">
              <img src={LogoImageVNL} alt="VeiligheidNL" />
            </CoreLink>
            <h1>{t(`form.newsletter.${formSuccess ? 'create_success' : 'title'}`)}</h1>
          </div>
          <div className="PageMinimal__content">
            {formSuccess
              ? (
                <div>
                  <WysiwygField
                    property="schema:text"
                    html={t('form.newsletter.create_success_message')}
                  />
                </div>
              )
              : (
                <>
                  <p>{t('spotler.newsletter_notice')}</p>
                  <SpotlerSubscriptionForm
                    subscriptionSource={email ? GTM_SOURCE_BANNER : GTM_SOURCE_NEWSLETTER_PAGE}
                    hideEmail={false}
                    onSuccess={() => {
                      setFormSuccess(true);
                    }}
                  />
                </>
              )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SpotlerSubscription;
